import pattern from './pattern';

const commonTable = [
  {
    value: 'date',
    name: '日期'
  },
  {
    value: 'name',
    name: '姓名'
  }
];

const classTable = [
  {
    value: 'date',
    name: '日期'
  },
  {
    value: 'name',
    name: '姓名'
  }
];
// 教学楼列表
const buildingTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'name',
    name: '教学楼名称',
    editOptions: {
      type: 'text',
      pattern: pattern.noEmpty
    }
  },
  {
    value: 'position',
    name: '位置',
    editOptions: {
      type: 'text',
      pattern: pattern.noEmpty
    }
  },
  {
    value: 'total_floor',
    name: '总楼层',
    editOptions: {
      type: 'text',
      pattern: pattern.number
    }
  },
  {
    value: 'classroom_count',
    name: '教室数量',
    editOptions: {
      type: 'text',
      pattern: pattern.number
    }
  },
  {
    value: 'activate_status',
    name: '状态',
    editOptions: {
      type: 'status'
    }
  },
  {
    value: 'schedule_template',
    name: '课程表导出模板'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '156px'
    }
  }
];

// 教学楼列表
const roomTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'name',
    name: '教室名称'
  },
  {
    value: 'building_name',
    name: '楼栋'
  },
  {
    value: 'floor',
    name: '楼层'
  },
  {
    value: 'code',
    name: '教室号'
  },
  {
    value: 'seat_num',
    name: '座位数'
  },
  {
    value: 'has_multimedia_equipment',
    name: '多媒体设备'
  },
  {
    value: 'class_count',
    name: '课次数量'
  },
  {
    value: 'use',
    name: '使用情况'
  },
  {
    value: 'activate_status',
    name: '状态',
    editOptions: {
      type: 'status',
      hasPermission: 'class_room_deactive'
    }
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '154px'
    }
  }
];
// 级别列表
const gradeTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'name',
    name: '级别名称'
  },
  {
    value: 'org_name',
    name: '所属部门'
  },
  {
    value: 'specialized_subject_full_name',
    name: '所属项目'
  },
  {
    value: 'class_size',
    name: '班级人数'
  },
  {
    value: 'single_class_duration',
    name: '单节时长（分钟）'
  },
  {
    value: 'single_class_price',
    name: '单节课费（元）'
  },
  {
    value: 'activate_status',
    name: '状态',
    editOptions: {
      type: 'status'
    }
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '154px'
    }
  }
];
// 项目列表
const specialTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'specialized_subject_full_name',
    name: '项目名称'
  },
  {
    value: 'specialized_subject_code',
    name: '项目代码'
  },
  {
    value: 'create_time',
    name: '加入时间'
  },
  {
    value: 'action',
    name: '操作'
  }
];

// 打折理由列表
const discountTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'reason',
    name: '打折理由'
  },
  {
    value: 'rate',
    name: '默认折扣率'
  },
  {
    value: 'activate_status',
    name: '状态',
    editOptions: {
      type: 'status'
    }
  },
  {
    value: 'remarks',
    name: '备注'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '154px'
    }
  }
];

// 系统用户（成员）列表
const sysMember = [
  {
    option: {
      type: 'selection',
      'reserve-selection': true
    }
  },
  {
    value: 'username',
    name: '登录账号'
  },
  {
    value: 'real_name',
    name: '真实姓名'
  },
  {
    value: 'id_card_no',
    name: '身份证号'
  },
  {
    value: 'role_names',
    name: '所属角色'
  },
  {
    value: 'specialized_subject_full_names',
    name: '拥有项目'
  },
  {
    value: 'job',
    name: '职务'
  },
  {
    value: 'activate_status',
    name: '状态',
    editOptions: {
      type: 'status'
    }
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '160px'
    }
  }
];

const teacherTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'username',
    name: '用户名'
  },
  {
    value: 'real_name',
    name: '姓名'
  },
  {
    value: 'telephone',
    name: '手机号',
    option: {
      width: '100px'
    }
  },
  {
    value: 'org_full_names',
    name: '任教部门'
  },
  {
    value: 'specialized_subject_names',
    name: '任教项目'
  },
  {
    value: 'education',
    name: '学历'
  },
  {
    value: 'contract_type',
    name: '合同类型'
  },
  {
    value: 'contract_time',
    name: '合同期限',
    option: {
      width: '110px'
    }
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'age',
    name: '年龄'
  },
  {
    value: 'id_card_no',
    name: '证件号'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '140px'
    }
  }
];

const regUserTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'username',
    name: '用户名'
  },
  {
    value: 'real_name',
    name: '真实姓名'
  },
  {
    value: 'phone',
    name: '电话'
  },
  {
    value: 'id_card_type',
    name: '证件类型',
    isHide: true
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'age',
    name: '年龄'
  },
  {
    value: 'id_card_no',
    name: '证件号码',
    isHide: true
  },
  {
    value: 'nick_name',
    name: '微信昵称'
  },
  {
    value: 'create_time',
    name: '注册时间'
  },
  // {
  //   value: 'activate_status',
  //   name: '状态',
  //   editOptions: {
  //     type: 'status'
  //   }
  // },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '134px'
    }
  }
];

const regUserRelationsTable = [
  {
    value: 'name',
    name: '姓名'
  },
  {
    value: 'id_card_type',
    name: '证件类型'
  },
  {
    value: 'id_card_no',
    name: '证件号码'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'age',
    name: '年龄'
  },
  {
    value: 'birthday',
    name: '生日'
  },
  {
    value: 'grade',
    name: '年级'
  },
  {
    value: 'relation',
    name: '关系'
  },
  {
    value: 'often_address',
    name: '常住地址'
  },
  {
    value: 'cohabitation',
    name: '共居人'
  },
  {
    value: 'transfer',
    name: '主要接送人'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '164px'
    }
  }
];

const holidayTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'name',
    name: '假日名称'
  },
  {
    value: 'year',
    name: '年度'
  },
  {
    value: 'start_date',
    name: '开始时间'
  },
  {
    value: 'end_date',
    name: '结束时间'
  },
  {
    value: 'create_time',
    name: '创建时间'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '164px'
    }
  }
];

const termTable = [
  {
    value: 'term',
    name: '学期'
  },
  {
    value: 'code',
    name: '学期代码'
  },
  {
    value: 'type',
    name: '学员出生日期范围计算方式'
  }
];
const accessTable = [
  {
    value: 'term',
    name: '学期'
  },
  {
    value: 'effectiveTime',
    name: '门禁有效期'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const baseFlowTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'name',
    name: '流程名称'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const studentTable = [
  {
    option: {
      type: 'index',
      width: 66
    }
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'age',
    name: '年龄'
  },
  {
    value: 'id_card_type',
    name: '证件类型'
  },
  {
    value: 'id_card_no',
    name: '身份证号'
  },
  {
    value: 'birthday',
    name: '出生日期'
  },
  {
    value: 'real_name',
    name: '家长姓名'
  },
  {
    value: 'phone',
    name: '家长电话'
  },
  {
    value: 'first_pay_time',
    name: '首次缴费时间'
  }
];
const studentSignTable = [
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'year',
    name: '学年'
  },
  {
    value: 'term',
    name: '学期'
  },
  {
    value: 'name',
    name: '班级名称'
  },
  {
    value: 'class_code',
    name: '班级代码',
    isHide: true
  },
  {
    value: 'org_full_name',
    name: '所属部门'
  },
  {
    value: 'specialized_subject_full_name',
    name: '所属项目'
  },
  {
    value: 'sign_up_fee',
    name: '应付金额（元）'
  },
  {
    value: 'real_fee',
    name: '实付金额（元）'
  },
  {
    value: 'sign_up_type',
    name: '报名方式'
  },
  {
    value: 'sign_up_status',
    name: '报名状态'
  }
];

const salaryManageTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'teacher_name',
    name: '教师姓名'
  },
  {
    value: 'month',
    name: '月份'
  },
  {
    value: 'specialized_subject_name',
    name: '项目'
  },
  {
    value: 'class_name',
    name: '班级名称'
  },
  {
    value: 'class_code',
    name: '班级代码',
    isHide: true
  },
  {
    value: 'class_rate',
    name: '课酬率'
  },
  {
    value: 'courses_count',
    name: '课次'
  },
  {
    value: 'class_fee',
    name: '总学费'
  },
  {
    value: 'semester_remuneration',
    name: '总课酬'
  },
  {
    value: 'allSupFee',
    name: '代课/缺课'
  },
  {
    value: 'current_month_remuneration',
    name: '本月课酬'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const salaryDetailTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'real_name',
    name: '教师姓名'
  },
  {
    value: 'month',
    name: '月份'
  },
  {
    value: 'specialized_subject_name',
    name: '项目'
  },
  {
    value: 'class_name',
    name: '班级名称'
  },
  {
    value: 'class_code',
    name: '班级代码',
    isHide: true
  },
  {
    value: 'remuneration_rate',
    name: '课酬率'
  },
  {
    value: 'courses_count',
    name: '课次'
  },
  {
    value: 'study_fee_income',
    name: '总学费'
  },
  {
    value: 'month_remuneration',
    name: '总课酬'
  },
  {
    value: 'allSupFee',
    name: '代课/缺课'
  },
  {
    value: 'other',
    name: '其他'
  },
  {
    value: 'month_real_salary',
    name: '本月课酬'
  }
  // {
  //   value: 'action',
  //   name: '操作'
  // }
];
const mySalaryDetailTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'id_card_no',
    name: '身份证号'
  },
  {
    value: 'month',
    name: '月份'
  },
  {
    value: 'specialized_subject_name',
    name: '项目'
  },
  {
    value: 'class_name',
    name: '班级名称'
  },
  {
    value: 'class_code',
    name: '班级代码',
    isHide: true
  },
  {
    value: 'remuneration_rate',
    name: '课酬率'
  },
  {
    value: 'courses_count',
    name: '课次'
  },
  {
    value: 'study_fee_income',
    name: '总学费'
  },
  {
    value: 'month_remuneration',
    name: '总课酬'
  },
  {
    value: 'allSupFee',
    name: '代课/缺课'
  },
  {
    value: 'other',
    name: '其他'
  },
  {
    value: 'month_real_salary',
    name: '本月课酬'
  }
];
const financePayTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'root_specialized_subject_name',
    name: '项目大类'
  },
  {
    value: 'specialized_subject_name',
    name: '项目'
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'contact_name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '证件号'
  },
  {
    value: 'pay_time',
    name: '缴费时间'
  },
  {
    value: 'sign_up_fee_real_fee',
    name: '应收/实收'
  },
  {
    value: 'reduction',
    name: '折扣'
  },
  {
    value: 'already_supply_fee_refund_fee',
    name: '已补/已退'
  },
  {
    value: 'audit_supply_fee',
    name: '补费中'
  },
  {
    value: 'audit_refund_fee',
    name: '退款中'
  },
  {
    value: 'class_name',
    name: '班级'
  },
  {
    value: 'refund_time',
    name: '退费时间'
  },
  {
    value: 'keep_reserved',
    name: '保留名额'
  },
  {
    value: 'sign_up_status',
    name: '状态',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'pay_type',
    name: '支付方式',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'action',
    name: '退款申请'
  }
];

const briefedTable = [
  {
    value: 'title',
    name: '标题'
  },
  {
    value: 'create_time',
    name: '发布时间'
  },
  {
    value: 'is_use',
    name: '启用状态'
  },
  {
    value: 'is_show',
    name: '轮播状态'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const infoNoticeTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'title',
    name: '标题'
  },
  {
    value: 'release_time',
    name: '发布时间'
  },
  {
    value: 'notice_state',
    name: '状态'
  },
  {
    value: 'views',
    name: '游览量'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const fenceTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'name',
    name: '围栏名称'
  },
  {
    value: 'org_name',
    name: '部门'
  },
  {
    value: 'names',
    name: '人员',
    width: '400px'
  },
  {
    value: 'operator',
    name: '创建人'
  },
  {
    value: 'create_time',
    name: '创建时间'
  },
  {
    value: 'status',
    name: '有效性'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const infoNoticeReadTable = [
  {
    value: 'org_name',
    name: '部门'
  },
  {
    value: 'specialized_subject_name',
    name: '项目'
  },
  {
    value: 'class_name',
    name: '级别'
  },
  {
    value: 'contact_name',
    name: '姓名'
  },
  {
    value: 'read_time',
    name: '阅读时间'
  },
  {
    value: 'is_read',
    name: '阅读状态'
  }
];
const infoConfirmTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'title',
    name: '标题'
  },
  {
    value: 'release_time',
    name: '发布时间'
  },
  {
    value: 'notice_state',
    name: '状态'
  },
  {
    value: 'is_confirm',
    name: '确认情况'
  },
  {
    value: 'views',
    name: '游览量'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const newsTable = [
  {
    value: 'venue_name',
    name: '标题'
  },
  {
    value: 'create_time',
    name: '发布时间'
  },
  {
    value: 'is_use',
    name: '启用状态'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const ideaTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'title',
    name: '标题'
  },
  {
    value: 'type',
    name: '类型'
  },
  {
    value: 'content',
    name: '内容'
  },
  {
    value: 'create_time',
    name: '提交时间'
  },
  {
    value: 'real_name',
    name: '联系人'
  },
  {
    value: 'phone',
    name: '联系电话'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const coopTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'explain',
    name: '合作说明'
  },
  {
    value: 'organization',
    name: '类型'
  },
  {
    value: 'company',
    name: '名称'
  },
  {
    value: 'indoor_area',
    name: '室内（㎡）'
  },
  {
    value: 'outdoor_area',
    name: '室外（㎡）'
  },
  {
    value: 'create_time',
    name: '提交时间'
  },
  {
    value: 'real_name',
    name: '提交人'
  },
  {
    value: 'phone',
    name: '联系方式'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const problemTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'question',
    name: '问题名称'
  },
  {
    value: 'is_use',
    name: '状态'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const contactTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'org_name',
    name: '部门'
  },
  {
    value: 'specialized_subject_names',
    name: '项目'
  },
  {
    value: 'contact_info',
    name: '联系信息'
  },
  {
    value: 'is_use',
    name: '状态'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const userContactTable = [
  {
    value: 'name',
    name: '姓名'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'age',
    name: '年龄'
  },
  {
    value: 'nationality',
    name: '国籍',
    isHide: true
  },
  {
    value: 'id_card_type',
    name: '证件类型'
  },
  {
    value: 'id_card_no',
    name: '证件号码'
  },
  {
    value: 'document_photo',
    name: '证件照片'
  },
  {
    value: 'grade',
    name: '年级'
  },
  {
    value: 'register_user_name',
    name: '监护人用户名'
  },
  {
    value: 'register_user_phone',
    name: '监护人手机'
  },
  {
    value: 'relation',
    name: '监护人关系',
    isHide: true
  },
  {
    value: 'audit_time',
    name: '审核时间'
  },
  {
    value: 'audit_user_name',
    name: '审核人'
  },
  {
    value: 'modify_time',
    name: '更新时间',
    isHide: true
  },
  {
    value: 'audit_status',
    name: '状态'
  },
  // {
  //   value: 'activate_status',
  //   name: '状态',
  //   editOptions: {
  //     type: 'status'
  //   }
  // },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '90px'
    }
  }
];
const financeOrderTable = [
  {
    value: 'order_number',
    name: '订单号'
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'pay_time',
    name: '交易时间'
  },
  {
    value: 'pay_end_time',
    name: '缴费截至时间'
  },
  {
    value: 'username',
    name: '支付账号'
  },
  {
    value: 'object_type',
    name: '商品类型'
  },
  {
    value: 'name',
    name: '商品名称'
  },
  {
    value: 'fee',
    name: '订单金额（元）'
  },
  {
    value: 'pay_type',
    name: '支付方式'
  },
  {
    value: 'pay_status',
    name: '订单状态'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const paySupplyTable = [
  {
    value: 'supply_no',
    name: '补费单号'
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'contact_name',
    name: '申请学员'
  },
  {
    value: 'id_card_no',
    name: '证件号'
  },
  {
    value: 'total_fee',
    name: '补费金额'
  },
  {
    value: 'org_name',
    name: '部门'
  },
  {
    value: 'class_name',
    name: '班级名称'
  },
  {
    value: 'create_time',
    name: '申请时间'
  },
  {
    value: 'supply_time',
    name: '补费时间'
  },
  {
    value: 'supply_fee_status',
    name: '补费状态'
  },
  {
    value: 'supply_fee_method',
    name: '补费方式'
  },
  {
    value: 'operate_user_name',
    name: '操作员'
  }
  // {
  //   value: 'action',
  //   name: '操作'
  // }
];
const financeRefundTable = [
  {
    value: 'refund_number',
    name: '退款单号'
  },
  {
    value: 'order_number',
    name: '订单号'
  },
  {
    value: 'create_time',
    name: '提交时间'
  },
  {
    value: 'username',
    name: '支付账号'
  },
  {
    value: 'pay_type',
    name: '支付方式'
  },
  {
    value: 'refund_type',
    name: '退费类型'
  },
  {
    value: 'name',
    name: '商品名称'
  },
  {
    value: 'refund_fee',
    name: '退款金额（元）'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const financeIncomeTable = [
  {
    value: 'org_name',
    name: '部门'
  },
  {
    value: 'class_fee',
    name: '课酬收入'
  },
  {
    value: 'c',
    name: '课酬支出'
  },
  {
    value: 'd',
    name: '课酬利润'
  }
];

const payCountTable = [
  {
    value: 'name',
    name: '名称'
  },
  {
    value: 'class_code',
    name: '班级代码'
  },
  {
    value: 'class_fee',
    name: '学费'
  },
  {
    value: 'insurance',
    name: '保险费'
  },
  {
    value: 'material_fee',
    name: '材料费'
  },
  /*  {
    value: 'hosting_fee',
    name: '托管费'
  }, */
  {
    value: 'food_expenses',
    name: '伙食费'
  },
  /*  {
    value: 'accompanying_fee',
    name: '陪读费'
  }, */
  {
    value: 'accommodation_traffic_ticket',
    name: '食宿交通门票等'
  },
  {
    value: 'class_size',
    name: '预招人数'
  },
  {
    value: 'paid_count',
    name: '缴费人数'
  },
  {
    value: 'real_total_fee',
    name: '缴费金额'
  },
  {
    value: 'refund_count',
    name: '退费人数'
  },
  {
    value: 'refund_count_money',
    name: '退款金额'
  },
  {
    value: 'real_course_count',
    name: '实际上课人数'
  },
  {
    value: 'total_fee',
    name: '实际收入'
  }
  // {
  //   value: 'action',
  //   name: '操作',
  //   option: {
  //     width: '74px'
  //   }
  // }
];

const payDiscountTable = [
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'contact_name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '证件号'
  },
  {
    value: 'class_name',
    name: '班级名称'
  },
  {
    value: 'class_code',
    name: '班级代码',
    isHide: true
  },
  {
    value: 'class_total_fee',
    name: '应收金额'
  },
  {
    value: 'reduction',
    name: '折扣金额'
  },
  {
    value: 'real_fee',
    name: '实收金额'
  },
  {
    value: 'is_discount',
    name: '是否打折'
  },
  {
    value: 'discount_time',
    name: '打折时间'
  },
  {
    value: 'reason',
    name: '打折理由'
  },
  {
    value: 'is_shift',
    name: '是否插班'
  },
  {
    value: 'discount_operator_name',
    name: '操作员'
  },
  {
    value: 'sign_up_status',
    name: '缴费状态'
  },
  {
    value: 'pay_time',
    name: '缴费时间'
  },
  {
    value: 'pay_type',
    name: '支付方式'
  }
];
const invoiceTable = [
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'contact_name',
    name: '学员姓名'
  },
  {
    value: 'name',
    name: '班级名称'
  },
  {
    value: 'org_name',
    name: '班级部门'
  },
  {
    value: 'invoice_title',
    name: '发票抬头'
  },
  {
    value: 'unit_name',
    name: '单位名称'
  },
  {
    value: 'identification_number',
    name: '纳税识别号'
  },
  {
    value: 'phone_of_receiver',
    name: '手机号码'
  },
  {
    value: 'mailbox_of_receiver',
    name: '电子邮箱'
  },
  {
    value: 'invoice_fee',
    name: '金额(元)'
  },
  {
    value: 'create_time',
    name: '申请时间'
  },
  {
    value: 'invoice_status',
    name: '状态'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '74px'
    }
  }
];

const contractTable = [
  {
    value: 'contract_type',
    name: '合同类型'
  },
  {
    value: 'contract_date',
    name: '合同时间'
  },
  {
    value: 'contract_status',
    name: '合同状态'
  },
  {
    value: 'modify_time',
    name: '操作时间'
  },
  {
    value: 'operate_user_name',
    name: '操作人'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '204px'
    }
  }
];
const sysMessageTable = [
  {
    value: 'title',
    name: '标题'
  },
  {
    value: 'send_user_name',
    name: '发送人'
  },
  {
    value: 'create_time',
    name: '发送时间'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '204px'
    }
  }
];

const perMessageTable = [
  {
    value: 'title',
    name: '标题'
  },
  {
    value: 'send_user_name',
    name: '发送人'
  },
  {
    value: 'create_time',
    name: '发送时间'
  }
  // {
  //   value: 'action',
  //   name: '操作'
  // }
];

const reportLotteryTable = [
  {
    name: '部门',
    value: 'org_name'
  },
  {
    name: '项目大类',
    value: 'root_specialized_subject_name'
  },
  {
    name: '项目',
    value: 'specialized_subject_name'
  },
  {
    value: 'class_code',
    name: '班级代码'
  },
  {
    value: 'class_info_name',
    name: '班级名称'
  },
  {
    value: 'record_sign_up_quota_until_rocking',
    name: '剩余名额'
  },
  {
    value: 'rocking_success_count',
    name: '中签人数'
  },
  {
    value: 'rocking_success_pay_count',
    name: '中签后缴费人数'
  },
  {
    value: 'rocking_fill_count',
    name: '递补人数'
  },
  {
    value: 'rocking_fill_pay_count',
    name: '递补后缴费人数'
  },
  {
    value: 'replenish_pay_count',
    name: '补充报名缴费人数'
  },
  {
    value: 'rocking_number_count',
    name: '摇号人数'
  },
  {
    value: 'rocking_success_rate',
    name: '中签率'
  }
];

const reportRoomTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'class_room_name',
    name: '教室名称'
  },
  {
    value: 'class_usage',
    name: '班级使用数量'
  },
  {
    value: 'total_lessons',
    name: '总课次'
  },
  {
    value: 'total_sign_up',
    name: '总报名人数'
  },
  {
    value: 'total_fee',
    name: '总收费金额'
  },
  {
    value: 'class_usage_rate',
    name: '班级使用率'
  },
  {
    value: 'action',
    name: '明细'
  }
];
const reportRoomNextTable = [
  {
    value: 'datetime',
    name: '日期'
  },
  {
    value: 'classroom_name',
    name: '教室名称'
  },
  {
    value: 'class_name',
    name: '班级名称'
  },
  {
    value: 'class_time',
    name: '上课时间'
  },
  {
    value: 'valid_use_rate',
    name: '有效使用率（7:00点-21:00点)'
  }
];

const reportRooDetailTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'name',
    name: '班级名称'
  },
  {
    value: 'class_time',
    name: '上课时间'
  },
  {
    value: 'courses_count',
    name: '课次'
  },
  {
    value: 'sign_up_count',
    name: '报名人数'
  },
  {
    value: 'total_fee',
    name: '收费金额（元）'
  }
];

const studentInscTable = [
  {
    value: 'contact_name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '身份证号'
  },
  {
    value: 'class_name',
    name: '班级名称'
  },
  {
    value: 'username',
    name: '关联用户'
  },
  {
    value: 'phone',
    name: '家长电话'
  },
  {
    value: 'insurance',
    name: '金额（元）'
  },
  {
    value: 'pay_time',
    name: '缴费时间'
  }
];

const applyTable = [
  {
    value: 'supply_time',
    name: '补费时间'
  },
  {
    value: 'total_fee',
    name: '补费金额'
  },
  {
    value: 'supply_fee_status',
    name: '补费状态'
  },
  {
    value: 'supply_fee_remains',
    name: '剩余补费'
  },
  {
    value: 'class_fee',
    name: '学费'
  },
  {
    value: 'insurance',
    name: '保险费'
  },
  {
    value: 'food_expenses',
    name: '伙食费'
  },
  /*  {
    value: 'accompanying_fee',
    name: '陪读费'
  }, */
  {
    value: 'material_fee',
    name: '材料费'
  },
  /*  {
    value: 'hosting_fee',
    name: '托管费'
  }, */
  {
    value: 'accommodation_traffic_ticket',
    name: '食宿交通门票等'
  },
  {
    value: 'operate_user_name',
    name: '补费申请人'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const refundTable = [
  {
    value: 'create_time',
    name: '退费时间'
  },
  {
    value: 'total_fee',
    name: '退费金额'
  },
  {
    value: 'class_fee',
    name: '学费'
  },
  {
    value: 'insurance',
    name: '保险费'
  },
  {
    value: 'food_expenses',
    name: '伙食费'
  },
  /*  {
    value: 'accompanying_fee',
    name: '陪读费'
  }, */
  {
    value: 'material_fee',
    name: '材料费'
  },
  /*  {
    value: 'hosting_fee',
    name: '托管费'
  }, */
  {
    value: 'accommodation_traffic_ticket',
    name: '食宿交通门票等'
  },
  {
    value: 'operate_name',
    name: '操作人'
  }
];

const applyTableDrawer = [
  {
    value: 'total_fee',
    name: '补费金额'
  },
  {
    value: 'create_time',
    name: '申请时间'
  },
  {
    value: 'supply_no',
    name: '补费单号'
  },
  {
    value: 'supply_fee_status',
    name: '状态'
  },
  {
    value: 'modify_time',
    name: '状态更新时间'
  },
  {
    value: 'apply_user_name',
    name: '申请人'
  }
];
const refundTableDrawer = [
  {
    value: 'total_fee',
    name: '退款金额'
  },
  {
    value: 'create_time',
    name: '申请时间'
  },
  {
    value: 'refund_number',
    name: '退款单号'
  },
  {
    value: 'refund_status',
    name: '状态'
  },
  {
    value: 'modify_time',
    name: '状态更新时间'
  },
  {
    value: 'operate_name',
    name: '申请人'
  }
];

const refundPageTable = [
  {
    value: 'refund_number',
    name: '退款单号',
    option: {
      width: '130px'
    }
  },
  {
    value: 'reservation_number',
    name: '缴费预约号'
  },
  {
    value: 'contact_name',
    name: '申请学员'
  },
  {
    value: 'id_card_no',
    name: '身份证号'
  },
  {
    value: 'year',
    name: '学年'
  },
  {
    value: 'term',
    name: '学期'
  },
  {
    value: 'class_code',
    name: '班级代码'
  },
  {
    value: 'class_name',
    name: '退费班级'
  },
  {
    value: 'org_name',
    name: '部门'
  },
  {
    value: 'specialized_subject_full_name',
    name: '项目大类'
  },
  {
    value: 'specialized_subject_child_name',
    name: '项目'
  },
  {
    value: 'refund_type',
    name: '退费类型'
  },
  {
    value: 'total_fee',
    name: '退费金额'
  },
  {
    value: 'real_fee',
    name: '实际缴费'
  },
  {
    value: 'refund_source',
    name: '退费来源'
  },
  {
    value: 'refund_reason',
    name: '退费原因'
  },
  {
    value: 'create_time',
    name: '申请时间'
  },
  {
    value: 'operate_name',
    name: '操作员'
  },
  {
    value: 'refund_status',
    name: '状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '100px'
    }
  }
];
const announcementTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'title',
    name: '标题'
  },
  {
    value: 'publisher',
    name: '发送人'
  },
  {
    value: 'publish_time',
    name: '发送时间'
  },
  {
    value: 'publish_status',
    name: '是否发布'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const appVersionTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'version_number',
    name: '版本号'
  },
  {
    value: 'version_code',
    name: '版本代码号'
  },
  {
    value: 'app_type',
    name: '类型'
  },
  {
    value: 'version_status',
    name: '是否激活'
  },
  {
    value: 'download_url',
    name: '下载地址'
  },
  {
    value: 'update_description',
    name: '更新说明'
  },
  {
    value: 'publish_date',
    name: '更新日期'
  },
  {
    value: 'pkg_size',
    name: '包大小'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const newsTypeTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'news_category_name',
    name: '类别名称'
  },
  {
    value: 'news_category_code',
    name: '列表标识'
  },
  {
    value: 'modify_time',
    name: '更新时间'
  },
  {
    value: 'news_number',
    name: '资讯数量'
  },
  {
    value: 'read_count',
    name: '总浏览量'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const newsContentTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'content_title',
    name: '标题'
  },
  {
    value: 'news_category_name',
    name: '类别'
  },
  {
    value: 'update_time',
    name: '更新时间'
  },
  {
    value: 'activate_status',
    name: '状态'
  },
  {
    value: 'read_count',
    name: '浏览量'
  },
  {
    value: 'action',
    name: '操作'
  }
];
const transferRecordTable = [
  {
    value: 'new_class_year',
    name: '新班学年'
  },
  {
    value: 'new_class_term',
    name: '新班学期'
  },
  {
    value: 'new_class_name',
    name: '新班名称'
  },
  {
    value: 'original_class_year',
    name: '旧班学年'
  },
  {
    value: 'original_class_term',
    name: '旧班学期'
  },
  {
    value: 'original_class_name',
    name: '旧班名称'
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'create_time',
    name: '转班时间'
  },
  {
    value: 'operate_user_name',
    name: '操作人'
  }
];
const refundRequestTable = [
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '证件号'
  },
  {
    value: 'class_name',
    name: '报名班级'
  },
  {
    value: 'sign_up_fee_real_fee',
    name: '实收/应收'
  },
  {
    value: 'refund_reason',
    name: '申请退款原因'
  },
  {
    value: 'create_time',
    name: '申请时间'
  },
  {
    value: 'contact_phone',
    name: '联系方式'
  },
  {
    value: 'pay_status',
    name: '状态',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'pay_type',
    name: '支付方式',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'refund_handler_name',
    name: '处理人'
  },
  {
    value: 'refund_handle_time',
    name: '处理时间'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      align: 'center'
    }
  }
];
const backStudyTable = [
  {
    name: '部门',
    value: 'org_name'
  },
  {
    name: '项目大类',
    value: 'root_specialized_subject_name'
  },
  {
    name: '项目',
    value: 'specialized_subject_name'
  },
  {
    name: '2019年（本学年）',
    value: 'compare_contact_count'
  },
  {
    name: '2019年（上学年）',
    value: 'cal_contact_count'
  },
  {
    name: '老生返读人数',
    value: 'back_student_count'
  },
  {
    name: '老生返读率',
    value: 'back_student_rate'
  }
];
/**
 * @param {Array} list(exp: ['date', 'name'])
 * @returns {Array} itemList(exp: [{
    value: 'date',
    name: '日期'
  },{
    value: 'name',
    name: '姓名'
  }])
 */

const tableFun = (list = []) => {
  if (!list.length) return [];
  const keys = [commonTable, classTable];
  const allList = (() => {
    const all = {};
    keys.map(item =>
      item.map(childItem => {
        if (typeof all[childItem.value] === 'undefined') {
          all[childItem.value] = childItem;
        }
        return {};
      }));
    return all;
  })();
  return list.map(item => allList[item]);
};

export {
  transferRecordTable,
  newsContentTable,
  newsTypeTable,
  appVersionTable,
  announcementTable,
  refundPageTable,
  refundTableDrawer,
  applyTableDrawer,
  refundTable,
  applyTable,
  studentInscTable,
  reportRooDetailTable,
  reportRoomNextTable,
  reportRoomTable,
  reportLotteryTable,
  paySupplyTable,
  sysMessageTable,
  perMessageTable,
  contractTable,
  commonTable,
  classTable,
  tableFun,
  buildingTable,
  gradeTable,
  specialTable,
  discountTable,
  sysMember,
  roomTable,
  teacherTable,
  regUserTable,
  regUserRelationsTable,
  holidayTable,
  baseFlowTable,
  studentTable,
  studentSignTable,
  salaryManageTable,
  financePayTable,
  briefedTable,
  newsTable,
  ideaTable,
  problemTable,
  contactTable,
  userContactTable,
  financeOrderTable,
  financeRefundTable,
  financeIncomeTable,
  payCountTable,
  payDiscountTable,
  coopTable,
  salaryDetailTable,
  mySalaryDetailTable,
  termTable,
  invoiceTable,
  refundRequestTable,
  accessTable,
  backStudyTable,
  infoNoticeTable,
  infoConfirmTable,
  infoNoticeReadTable,
  fenceTable
};
